import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { ObjectDateTransformer } from '../coaching-insight/coaching-insight.model';
import {
    catchErrorLogRet,
    mapList,
    mapRetrieve,
} from '../common/rest.operators';

import {
    TranscriptFocus,
    TranscriptSummary,
    TranscriptSummaryParams,
} from './general';

@Injectable()
export class TranscriptService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveSummary(
        summaryParams: TranscriptSummaryParams,
    ): Observable<TranscriptSummary> {
        let params = new HttpParams();
        if (summaryParams.startDate != null) {
            params = params.set('startDate', summaryParams.startDate.toJSON());
        }
        if (summaryParams.endDate != null) {
            params = params.set('endDate', summaryParams.endDate.toJSON());
        }
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/${summaryParams.userId}/transcript-summary`,
                { params },
            )
            .pipe(
                mapRetrieve(),
                map((ret) => {
                    const obj = {
                        transcripts: {
                            startDate: null,
                            endDate: null,
                            createdOn: null,
                        },
                    };
                    return new ObjectDateTransformer<TranscriptSummary>({
                        draft: obj,
                        active: obj,
                        closed: obj,
                        nonAssociated: obj,
                    }).transform(ret);
                }),
                catchErrorLogRet({}),
            );
    }

    updateFocuses(
        transcriptId: number,
        focuses: TranscriptFocus[],
    ): Observable<TranscriptFocus[]> {
        return this._http
            .patch(
                `${this._appConfig.API_ENDPOINTS.COACHING}/transcripts/${transcriptId}/focuses`,
                focuses,
            )
            .pipe(mapList(), catchErrorLogRet([]));
    }

    listFocuses(transcriptId: number): Observable<TranscriptFocus[]> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/transcripts/${transcriptId}/focuses`,
            )
            .pipe(mapList(), catchErrorLogRet([]));
    }
}
